import { IHealth } from 'src/types/health.type';
import http from 'src/utils/http';

export default class HealthService {
  private url = '/api/health';

  public async get() {
    const { data } = await http.get<IHealth>(`${this.url}`);
    return data;
  }
}
